/* global d3 $ */
import dataService from '../../service/dataService.js'
import pipeService from '../../service/pipeService.js';

let stopWordList = ["ourselves", "hers", "between", "yourself", "but", "again", "there", "about", "once", "during", "out", 
"very", "having", "with", "they", "own", "an", "be", "some", "for", "do", "its", "yours", "such", "into", "of", "most", 
"itself", "other", "off", "is", "s", "am", "or", "who", "as", "from", "him", "each", "the", "themselves", "until", 
"below", "are", "we", "these", "your", "his", "through", "don", "nor", "me", "were", "her", "more", "himself", 
"this", "down", "should", "our", "their", "while", "above", "both", "up", "to", "ours", "had", "she", "all", 
"no", "when", "at", "any", "before", "them", "same", "and", "been", "have", "in", "will", "on", "does", 
"yourselves", "then", "that", "because", "what", "over", "why", "so", "can", "did", "not", "now", "under", 
"he", "you", "herself", "has", "just", "where", "too", "only", "myself", "which", "those", "i", "after", 
"few", "whom", "t", "being", "if", "theirs", "my", "against", "a", "by", "doing", "it", "how", "further", "was", "here", "than"]

let q_backup = {
    "question": "hello",
    // "question_html": "qt",
    // "answer": {
    //     "A": "",
    //     "B": "",
    //     "C": "",
    //     "D": "",
    //     "E": ""
    // },
    "model_result": "", 
    "correct_choice": "", 
    "ground_truth": "", 
    // "relations": "relations", 
}
let a_backup = [{
    value: 'A',
    label: ''
}, {
    value: 'B',
    label: ''
}, {
    value: 'C',
    label: ''
}, {
    value: 'D',
    label: ''
}, {
    value: 'E',
    label: ''
}]
let initalize_questions = {
    "question": "James was looking for a good place to buy farmland. Where might he look?",
    "model_result": "", 
    "correct_choice": "A", 
    "ground_truth": "midwest", 
}

let initialze_choices = [{
    value: 'A',
    label: 'midwest'
}, {
    value: 'B',
    label: 'countryside'
}, {
    value: 'C',
    label: 'estate'
}, {
    value: 'D',
    label: 'farming areas'
}, {
    value: 'E',
    label: 'illinois'
}]



function drawBarChart(id, width, height, data, topn=20){
    console.log("drawBarChart data", id, width, height, data, topn);

    let word_counts = [];
    let maxFreq = 1;
    for(let i = 0; i<Object.keys(data).length; i++){
        let key = Object.keys(data)[i];
        let value = data[key];
        word_counts.push({
            "value": value,
            "freq": value,
            "key": key,
            "text": key
        });
        if(maxFreq < value) maxFreq = value;
    }
    word_counts.sort((a, b) => b.value - a.value);
    let new_word_counts = [];
    for(let i = 0; i<topn; i++){
        if(i < word_counts.length){
            word_counts[i]["id"] = i;
            new_word_counts.push(word_counts[i])
        }else{
            break;
        }
    }
    console.log("drawBarCharts sorted_word_count", new_word_counts);


    let top_svg = d3.select("#" + id)
    .append("svg")
    .attr("width", width)
    .attr("height", height);

    let text_height = 50;
    let bar_height = height - text_height;


    let freqSvg = top_svg;

    let wordFreqs = new_word_counts;
    let barWidth = width / topn;
    let freqHeight = bar_height;
    let barFillColor = "#7FBCD2"
    let minBarHeight = 1
    /*top_svg.append("rect")
    .attr("width", 50)
    .attr("height", 50)
    .style("fill", "lightblue")*/

    // X axis
    var x = d3.scaleBand()
        .range([0, barWidth * wordFreqs.length])
        .domain(wordFreqs.map(d => d.id))
        .padding(0.1);
    console.log("drawBarChart", x, wordFreqs.map(d => d.id), width, barWidth, x(1), x(2))

    // Add Y axis
    var y = d3.scaleLinear()
        .domain([0, maxFreq])
        .range([ freqHeight, 0]);
    console.log("drawBarChart", y, maxFreq, freqHeight, y(0), x(1));


    // Bars
    freqSvg.selectAll("mybar")
        .data(wordFreqs)
        .enter()
        .append("rect")
        .attr("x", function(d, i) { 
            // console.log(i, d, x(i)); 
            return x(i); 
        })
        .attr("y", function(d) { 
            if (freqHeight - y(d.freq) < minBarHeight) { return freqHeight - minBarHeight; }
            else { return y(d.freq); }
        })
        .attr("width", x.bandwidth())
        .attr("height", function(d) { 
            if (freqHeight - y(d.freq) < minBarHeight) { return minBarHeight; }
            else { return freqHeight - y(d.freq); }
        })
        .attr("fill", barFillColor)

    let wordTextGroup =  top_svg
        .append("g")
        .attr("id", id + "_text_group")
        .attr("transform", "translate(" + 0 + "," + (freqHeight) + ")");

    wordTextGroup.selectAll("myWordText")
        .data(wordFreqs)
        .enter()
        .append("text")
        .attr("class", "word-text")
        .attr("transform", function(d, i) { return "translate(" + (x(i) + barWidth / 4) + "," + 35 + ")" + " rotate(-60)"; })
        .text(function(d, i) { return d.text;})
        .style("font-weight", "100")
        .style("font-size", "12px")


    

}


export default {
    name: 'HistoryView',
    components: {
    },
    props: {},
    computed: {
        drawerHistory() {
            return {
                drawer: this.drawer,
                instances_history: this.instances_history
            }
        }
    },
    data() {
        return {
            // donut chart
            sections: [{ value: 70, color: "#7FBCD2" }],
            instances_history: [],
            instances_keys: {},
            drawer: false,
            model_result_flag: false,
            free_edit_question: initalize_questions,
            choice_options: initialze_choices,
            edited_feedback_flag: false,
            edited_feedback: {
                "selected_acc": 0,
                "pre_acc": 0,
                "post_acc":0 
            },
            freeEditChoiceBackground: {
                "A": "white", // "#AAAAAA", 
                "B": "white", // "#AAAAAA", 
                "C": "white", // "#AAAAAA", 
                "D": "white", // "#AAAAAA", 
                "E": "white", // "#AAAAAA", 
            },
            relation_accs: [{
                label: "at_location", 
                value: 76.85, 
            }, {
                label: "causes", 
                value: 68.53, 
            }], // with title and value
            dev_selected_acc: 80.00, 
        }
    },
    watch: {
        drawerHistory:function(drawerHistory){
            console.log("drawer, Instance History: ", drawerHistory);
            if(drawerHistory.drawer && (drawerHistory.instances_history.length>0)){
                let questionWidth = 600;
                let questionHeight = 100;
                let relWidth = 200;
                let relHeight = 100;
                let questionSVGWidth = ""+questionWidth+"px", questionSVGHeight = ""+questionHeight+"px"; // questions
                let relSVGWidth = ""+relWidth+"px", relSVGHeight = ""+relHeight+"px" //relations
                let question_words = {}, relation_words = {};
                
                drawerHistory.instances_history.map(q=>{
                    // handle question concept words
                    q.question.toLowerCase().replace(/[^\w\s]/gi, '').split(" ").map(w=>{
                        if(!stopWordList.includes(w)){
                            if(!question_words.hasOwnProperty(w)) {
                                question_words[w] = 0
                            }
                            question_words[w] = question_words[w] + 1
                        }
                    });
                    // handle question relations
                    let relations = q.relations;
                    if(typeof q.relations === 'string'){
                        relations = [q.relations]
                    }
                    relations.map(r=>{
                        if(!relation_words.hasOwnProperty(relations)){
                            relation_words[relations] = 0
                        }
                        relation_words[relations] = relation_words[relations] + 1
                    })
                    
                })
                ////////////////////////////////////// [DONE]
                // 另外，table column: "model results"需要对每一个row进行style渲染，我给了两种情况：model results对与错两种div css style
                // model results wrong:
                    // <div style="border: 2px solid lightpink; text-align: center">farming areas</div>
                    // model results correct:
                    // <div style="border: 2px solid rgb(147, 196, 125); text-align:center">feel pressure</div>
                 //////////////////////////////////////

                

                setTimeout(function(){
                    // initialize
                    d3.select("#question_col").selectAll("*").remove();
                    d3.select("#relation_col").selectAll("*").remove();
                    // instance history
                    // console.log("instances_history: ", drawerHistory.instances_history);
                    console.log("question_words, relation_words: ", question_words,relation_words);

                    
                    
                    // draw question bars
                    drawBarChart("question_col", questionWidth, questionHeight, question_words);
                    // draw relation bars
                    drawBarChart("relation_col", relWidth, relHeight, relation_words, 5);
                    /*d3.select("#relation_col")
                    .append("svg")
                    .attr("width", relSVGWidth)
                    .attr("height", relSVGHeight)
                    .append("rect")
                    .attr("width", 50)
                    .attr("height", 50)
                    .style("fill", "lightblue")*/
                    

                    // <text class="word-text" transform="translate(11.594745024875646,30) rotate(-60)">what</text>
                }, 500)

            }
        },
    },
    methods: {
        handleClose(done) {
            /*
            this.$confirm('Are you sure you want to close this?')
              .then(_ => {
                done();
              })
              .catch(_ => {});
              */
             done();
        }, 
        onApplyModelEdits: function () {
            if(this.instances_history.length > 0){
                console.log("onApplyModelEdits, ", this.instances_history);
                /*let examples = {
                    "edit_query": [{
                        "question": "James is looking for a good place to buy a farmland. Where might he look",
                        "choices": ["midwest", "countryside", "estate", "farming", "areas", "illinois"],
                        "target": "midwest"
                    },{
                        "question": "James is looking for a good place to buy a farmland. Where might he look",
                        "choices": ["midwest", "countryside", "estate", "farming", "areas", "illinois"],
                        "target": "midwest"
                    },{
                       "question": "James is looking for a good place to buy a farmland. Where might he look",
                        "choices": ["midwest", "countryside", "estate", "farming", "areas", "illinois"],
                        "target": "midwest"
                    }]
                }*/
                let edited_query = this.convertInstanceHistoryToEditQuery();
                dataService.editModelQA(edited_query, (data)=>{
                    console.log("return results of onApplyModelEdits, ", data);
                    this.clearInstanceHistory();
                    this.convertEditedQueryResultToInstanceHistory(data);
                    this.edited_feedback_flag = true;
                    this.edited_feedback.selected_acc = data["edit_success"];
                    this.sections = [{ 
                        value: data["edit_success"] * 100, 
                        color: "#7FBCD2" 
                    }]
                    this.edited_feedback.pre_acc = (data["pre_val_acc"] * 100).toFixed(2) + "%";
                    this.edited_feedback.post_acc = (data["post_val_acc"] * 100).toFixed(2) + "%";
                    this.$message({
                        message: 'Edit successfully.',
                        type: 'success'
                    });
                })
                // this.clearInstanceHistory();

            }else{
                this.$message({
                    message: 'No historical data.',
                    type: 'error'
                });
            }
        }, 
        onModelReload: function() {

        }, 
        convertInstanceHistoryToEditQuery: function(){
            let edit_query = [];
            for(let i = 0; i<this.instances_history.length; i++){
                let keys = ["A","B","C","D","E"];
                let curr_item = this.instances_history[i];
                let question = curr_item["question"];
                let target = curr_item["ground_truth"];
                let answer_set = [];
                for(let j = 0; j<keys.length; j++){
                    answer_set.push(curr_item["answer"][keys[j]]);
                }
                let new_item = {
                    "question": question,
                    "target": target,
                    "choices": answer_set,
                    "relations": curr_item["relations"]
                }
                edit_query.push(new_item);
            }
            return {
                "edit_query": edit_query
            }
        },
        convertEditedQueryResultToInstanceHistory: function (edited_query){
            let qa_instances = edited_query["qa_instances"];
            for(let i = 0; i<qa_instances.length; i++){
                let item = qa_instances[i];
                let answer_set = {}
                let keys = ["A","B","C","D","E"]
                for(let j = 0; j<keys.length; j++){
                    answer_set[keys[j]] = item["choices"][j]
                }
                let new_item = {
                    "question": item["question"],
                    "answer": answer_set,
                    "ground_truth": item["target"],
                    "model_result": item["edit_result"],
                    "relations": item["relations"]
                }
                this.saveInstance(new_item);
            }
        },
        clearInstanceHistory: function(){
            this.instances_keys = {};
            this.instances_history = [];
        },
        saveInstance: function(data){
            // Required keys from data: question, ans
            // Data come from the subset view, instead of main view.
            let fingerprint = data.question + "_" + data.answer.A + "_" + data.answer.B + "_" + data.answer.C + "_" + data.answer.D + "_" +data.answer.E;
            if(this.instances_keys.hasOwnProperty(fingerprint)){
                return ;
            }
            let key =  this.instances_history.length + 1;
            let new_data = {
                ...data,
                "key":key, 
                "fingerprint": fingerprint,
                "title": "ID: "+key+" Q:"+data.question
            }
            this.instances_keys[fingerprint] = key;
            this.instances_history.push(new_data);
            console.log("saveInstance save successfully.", new_data, this.instances_history);

        },
        onSaveFreeEdit: function() {
            // Data come from the subset view, instead of main view.
            // let fingerprint = this.free_edit_question.question + "_" + this.free_edit_question.answer.A + "_" + this.free_edit_question.answer.B + "_" + this.free_edit_question.answer.C + "_" + this.free_edit_question.answer.D + "_" +this.free_edit_question.answer.E;
            let fingerprint = this.free_edit_question.question + "_" + this.choice_options[0].label + "_" + this.choice_options[1].label + "_" + this.choice_options[2].label + "_" + this.choice_options[3].label + "_" + this.choice_options[4].label;
            this.free_edit_question.ground_truth = this.choice_options[this.free_edit_question.correct_choice.charCodeAt(0) - 'A'.charCodeAt(0)].label;
            if (this.instances_keys.hasOwnProperty(fingerprint)) {
                return ;
            }
            let key = this.instances_history.length + 1;
            let answer = {};
            for(let i = 0; i<this.choice_options.length; i++){
                let value = this.choice_options[i]["value"];
                let label = this.choice_options[i]["label"];
                answer[value] = label;
            }
            let new_data = {
                ...this.free_edit_question,
                "answer": answer,
                "key": key, 
                "fingerprint": fingerprint,
                "title": "ID: " + key + " Q:"+ this.free_edit_question.question
            }
            this.instances_keys[fingerprint] = key;
            this.instances_history.push(new_data);
            // console.log("save successfully.", new_data);
            this.$message({
                message: 'Save successfully.',
                type: 'success'
            });

        }, 
        onRunModelQA: function(){
            let choice_options = this.choice_options;
            let choices = []
            let ground_truth = "";
            for(let i = 0; i<choice_options.length; i++){
                choices.push(
                    choice_options[i]["label"]
                )
                if(choice_options[i]["value"] === this.free_edit_question.correct_choice){
                    ground_truth = choice_options[i]["label"]
                }
            }
            let question = this.free_edit_question.question;
            dataService.runModelQA({
                "question": question,
                "choices": choices,
            }, (result) => {
                console.log("Model return result: ", result)

                for (let i = 0; i<choice_options.length; i++) {
                    let value = choice_options[i]["value"]
                    let correct_color =   "#93C47D" // "#fb8072"  // '#59CE8F'
                    if (result === ground_truth) {

                        if (choice_options[i]["label"] === result) {
                            this.freeEditChoiceBackground[value] = correct_color;
                        } else {
                            this.freeEditChoiceBackground[value] = 'white'
                        }
                    } else {
                        if (choice_options[i]["label"] === ground_truth) {
                            this.freeEditChoiceBackground[value] = correct_color;
                        } else if (choice_options[i]["label"] === result) {
                            this.freeEditChoiceBackground[value] = "#EC5958";
                        } else {
                            this.freeEditChoiceBackground[value] = 'white'
                        }

                    }
                }
                this.free_edit_question.model_result = result;
                this.model_result_flag = true;
            })
        }
    },
    mounted: function() {
        ///////////////////////////////////    
        // //initialize table
        ///////////////////////////////////
        let _this = this;
        pipeService.onOpenDrawer(data => {
            _this.drawer = true;
            console.log("open drawer");
        })
        pipeService.onSaveInstances(data => {
            // Data come from the subset view, instead of main view.
            let fingerprint = data.question + "_" + data.answer.A + "_" + data.answer.B + "_" + data.answer.C + "_" + data.answer.D + "_" +data.answer.E;
            if(this.instances_keys.hasOwnProperty(fingerprint)){
                return ;
            }
            let key =  this.instances_history.length + 1;
            let new_data = {
                ...data,
                "key":key, 
                "fingerprint": fingerprint,
                "title": "ID: "+key+" Q:"+data.question
            }
            this.instances_keys[fingerprint] = key;
            this.instances_history.push(new_data);
            console.log("save successfully.", new_data, this.instances_history);
            this.$message({
                message: 'Save successfully.',
                type: 'success'
            });

        })
    },

}